import template from './view.html';
import controller from './view.controller';

let viewComponent = {
    restrict: 'E',
    require: {
        booking: '^booking'
    },
    template,
    controller,
    controllerAs: 'vm'
};

export default viewComponent;


// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/view/view.component.js